module.exports = __webpack_public_path__ + "static/media/blog.c9662696.svg";